import React, { useEffect, useState } from 'react'
import Button from '../../../../atoms/Button/Button'
import { api } from '../../../../../utils/index'
import { MODALITA_SPEDIZIONE, INDIRIZZI } from '../../../../../utils/endpoint'
import { useSelector } from 'react-redux'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import useTrans from '../../../../../hooks/useTrans'
import { trackingCheckout } from '../../../../../utils/gtm'
import { useRouter } from 'next/router'
import dynamic from 'next/dynamic'
import {
  getRequiredFields,
  getVisibleFields,
  hasDifferentRequiredFieldsIndirizzoFatturazione,
  isStepRequired,
} from '../../../../../utils/servicegift'
import IndirizzoCardCheckout from '../../../../molecules/IndirizzoCardCheckout/IndirizzoCardCheckout'
import { FormField } from '../../../../atoms'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'

const SceltaIndirizzoSg = dynamic(() =>
  import('../../../MyAccount/SceltaIndirizzoSg/SceltaIndirizzoSg')
)
const FormIndirizzoSg = dynamic(() => import('../../../MyAccount/FormIndirizzoSg/FormIndirizzoSg'))

const IndirizzoSpedizioneFatturazione = ({
  setStep,
  step,
  props,
  service_gift,
  carrello_main,
  handleScroll,
}) => {
  const { utente } = useSelector((state) => state.utente)
  const t = useTrans()
  const router = useRouter()

  const visibleFields = getVisibleFields(service_gift, utente.tipologia, 'checkout')
  const requiredFields = getRequiredFields(service_gift, utente.tipologia, 'checkout')

  const isSpedizioneVisibile = isStepRequired(
    service_gift,
    utente?.tipologia,
    'checkout',
    'indirizzo_spedizione',
    utente
  )
  const isFatturazioneVisibile = isStepRequired(
    service_gift,
    utente?.tipologia,
    'checkout',
    'indirizzo_fatturazione',
    utente
  )
  const isRichiediFatturaVisibile = isStepRequired(
    service_gift,
    utente?.tipologia,
    'checkout',
    'fattura',
    utente
  )
  const isFatturaRichiesta = isStepRequired(
    service_gift,
    utente?.tipologia,
    'checkout',
    'fattura_richiesta',
    utente
  )
  const isSpedizioneDiversa = isStepRequired(
    service_gift,
    utente?.tipologia,
    'checkout',
    'indirizzi_diversi',
    utente
  )
  const hasDifferentRequiredFieldsIndirizzi = hasDifferentRequiredFieldsIndirizzoFatturazione(
    service_gift,
    utente?.tipologia
  )

  const [indirizzi, setIndirizzi] = useState([])
  const [indirizziFatturazione, setIndirizziFatturazione] = useState([])
  const [selectedIndirizzo, setSelectedIndirizzo] = useState(
    props.values.indirizzo && props.values.indirizzo
  )
  const [selectedIndirizzoFatturazione, setSelectedIndirizzoFatturazione] = useState(
    props.values.indirizzo_fatturazione && props.values.indirizzo_fatturazione
  )
  const [loading, setLoading] = useState(false)
  const [indirizzoScelto, setIndirizzoScelto] = useState()
  const [indirizzoEdit, setIndirizzoEdit] = useState()
  const [indirizzoTmp, setIndirizzoTmp] = useState()

  const [showSceltaIndirizzoModal, setShowSceltaIndirizzoModal] = useState(false)
  const [showFormIndirizzoModal, setShowFormIndirizzoModal] = useState(false)

  const [tipoSpedizione, setTipoSpedizione] = useState(
    service_gift?.attivo ? 'corriere_sipec' : props.values.tipo_spedizione
  )

  const _setSelectedIndirizzoFatturazione = (indirizzo) => {
    if (props.values.fattura_richiesta && props.values.indirizzi_diversi) {
      setSelectedIndirizzoFatturazione(!indirizzo ? indirizzo : { ...indirizzo })
    }
  }

  const fetchIndirizzi = async (id) => {
    await api.get(INDIRIZZI).then((res) => {
      const indirizziData = res.data ? [...res.data.filter((x) => !x.is_fatturazione)] : []
      const indirizziFatturazioneData = res.data
        ? [...res.data.filter((x) => x.is_fatturazione)]
        : []

      const editedIndirizzo =
        indirizziData?.find((item) => item?.id === id) ||
        indirizziFatturazioneData?.find((item) => item?.id === id)

      setIndirizzi(indirizziData)
      setIndirizziFatturazione(indirizziFatturazioneData)

      if (!selectedIndirizzo) {
        setSelectedIndirizzo(
          indirizziData.filter((item, i) => item.preferenziale === true)?.[0] ||
            indirizziData.filter((item, i) => item.is_sede === true)?.[0] ||
            indirizziData?.[0]
        )
      } else {
        setSelectedIndirizzo(indirizziData.find((x) => x.id === selectedIndirizzo.id))
      }

      if (!selectedIndirizzoFatturazione) {
        _setSelectedIndirizzoFatturazione(
          indirizziFatturazioneData.filter((item, i) => item.preferenziale === true)?.[0] ||
            indirizziFatturazioneData.filter((item, i) => item.is_sede === true)?.[0] ||
            indirizziFatturazioneData?.[0]
        )
      } else {
        _setSelectedIndirizzoFatturazione(
          indirizziFatturazioneData.find((x) => x.id === selectedIndirizzoFatturazione.id)
        )
      }

      if (id) {
        if (editedIndirizzo?.is_fatturazione) {
          _setSelectedIndirizzoFatturazione(editedIndirizzo)
        } else {
          setSelectedIndirizzo(editedIndirizzo)
        }
      }

      // se ho modificato l'indirizzoScelto allora lo riassegno perchè è stato modificato
      if (indirizzoScelto) {
        setIndirizzoScelto(
          indirizzoScelto.is_fatturazione
            ? indirizziFatturazioneData?.find((x) => x.id === indirizzoScelto.id)
            : indirizziData?.find((x) => x.id === indirizzoScelto.id)
        )
      }

      setLoading(false)
    })
  }

  const showModals = (showSceltaIndirizzo, showFormIndirizzo) => {
    setShowFormIndirizzoModal(showFormIndirizzo)
    setShowSceltaIndirizzoModal(showSceltaIndirizzo)
  }

  const onClose = async (id) => {
    await fetchIndirizzi(id)
  }

  const setDefaultTipoSpedizione = () => {
    if (service_gift) {
      api
        .get(MODALITA_SPEDIZIONE, {
          params: {
            lang: router.locale,
          },
        })
        .then((res) =>
          props.setFieldValue(
            'tipo_spedizione_id',
            res.data.filter((tipo) => tipo.modalita === 'Spedizione')[0]?.id
          )
        )
    }
  }

  const handleAddIndirizzoInModal = () => {
    setIndirizzoEdit(null)
    showModals(false, true)
  }

  const handleSetIndirizzoInModal = () => {
    onClose(indirizzoTmp)
    setIndirizzoTmp(null)
    showModals(false, false)
  }

  const handleEditIndirizzoInModal = (indirizzo) => {
    setIndirizzoEdit(indirizzo)
    showModals(false, true)
  }

  const handleDeleteIndirizzoInModal = (indirizzoId) => {
    api
      .delete(`${INDIRIZZI}${indirizzoId}/`, { params: { lang: router.locale } })
      .then((response) => {
        onClose()
      })
      .catch((error) => console.log(error))
  }

  const handleAnnullaIndirizzoInModal = () => {
    setIndirizzoEdit(null)
    showModals(true, false)
  }

  const handleSaveIndirizzoInModal = () => {
    onClose(indirizzoTmp)
    setIndirizzoTmp(null)
    showModals(true, false)
  }

  useEffect(async () => {
    setLoading(true)

    if (service_gift) {
      props.setFieldValue('tipo_spedizione', 'corriere_sipec')
      props.setFieldValue('documento_trasporto', 'ts')
    }

    fetchIndirizzi()

    setDefaultTipoSpedizione()
  }, [])

  useEffect(() => {
    if (selectedIndirizzo) {
      props.setFieldValue('email_spedizione', selectedIndirizzo?.email || utente.email)
      props.setFieldValue('indirizzo', {
        ...selectedIndirizzo,
        is_italia: selectedIndirizzo?.nazione.codice === 'IT' ? true : false,
      })
    }
  }, [selectedIndirizzo])

  useEffect(() => {
    if (selectedIndirizzoFatturazione) {
      props.setFieldValue('indirizzo_fatturazione', {
        ...selectedIndirizzoFatturazione,
        is_italia: selectedIndirizzoFatturazione?.nazione.codice === 'IT' ? true : false,
      })
    }
  }, [selectedIndirizzoFatturazione])

  useEffect(() => {
    if (props.values.indirizzi_diversi && props.values.fattura_richiesta) {
      // se è richiesta fattura, imposto indirizzo default come fatturazione
      _setSelectedIndirizzoFatturazione(
        indirizziFatturazione.filter((item, i) => item.preferenziale === true)?.[0] ||
          indirizziFatturazione.filter((item, i) => item.is_sede === true)?.[0] ||
          indirizziFatturazione?.[0]
      )
    } else {
      props.setFieldValue('indirizzo_fatturazione', null)
    }
  }, [props.values.indirizzi_diversi, props.values.fattura_richiesta])

  useEffect(() => {
    if (!props.values.fattura_richiesta) {
      props.setFieldValue('indirizzo_fatturazione', null)
      props.setFieldValue('indirizzi_diversi', false)
    }
  }, [props.values.fattura_richiesta])

  useEffect(() => {
    if (hasDifferentRequiredFieldsIndirizzi) {
      props.setFieldValue('indirizzi_diversi', true)
    }
  }, [hasDifferentRequiredFieldsIndirizzi])

  const isIndirizziValid =
    (props.errors.indirizzo ? !Object.keys(props.errors.indirizzo).length : true) &&
    (props.errors.indirizzo_fatturazione
      ? !Object.keys(props.errors.indirizzo_fatturazione).length
      : true)

  if (loading) {
    return <LoadingSvg />
  }

  return (
    <>
      <div
        className={`checkout__indirizzo-spedizione-fatturazione ${
          service_gift ? 'checkout__indirizzo-spedizione-fatturazione--servicegift' : ''
        }`}
      >
        <div className="checkout__section">
          {isSpedizioneVisibile && (
            <>
              <p className="checkout__section-title">{t('Indirizzo di consegna')}</p>

              <IndirizzoCardCheckout
                variant="spedizione"
                indirizzo={selectedIndirizzo}
                onClick={() => {
                  if (selectedIndirizzo) {
                    setIndirizzoScelto(selectedIndirizzo)
                    showModals(true, false)
                  } else {
                    setIndirizzoScelto({ is_fatturazione: false })
                    handleAddIndirizzoInModal()
                  }
                }}
              />
            </>
          )}

          {!isFatturaRichiesta && isRichiediFatturaVisibile && (
            <FormField className="checkout__formfield">
              <FormCheckbox
                label={t('Richiedi fattura')}
                onChange={() => {
                  props.setFieldValue('fattura_richiesta', !props.values.fattura_richiesta)
                }}
                checked={props.values.fattura_richiesta}
                onBlur={props.handleBlur('fattura_richiesta')}
              />
            </FormField>
          )}

          {props.values.fattura_richiesta &&
            !hasDifferentRequiredFieldsIndirizzi &&
            isSpedizioneDiversa && (
              <FormField className="checkout__formfield">
                <FormCheckbox
                  label={t('Usa un indirizzo di fatturazione diverso da quello di spedizione')}
                  onChange={() =>
                    props.setFieldValue('indirizzi_diversi', !props.values.indirizzi_diversi)
                  }
                  checked={props.values.indirizzi_diversi}
                  onBlur={props.handleBlur('indirizzi_diversi')}
                />
              </FormField>
            )}

          {props.values.fattura_richiesta && props.values.indirizzi_diversi && (
            <>
              <p className="checkout__section-title">{t('Dati di fatturazione')}</p>

              <IndirizzoCardCheckout
                variant="fatturazione"
                indirizzo={selectedIndirizzoFatturazione}
                onClick={() => {
                  if (selectedIndirizzoFatturazione) {
                    setIndirizzoScelto(selectedIndirizzoFatturazione)
                    showModals(true, false)
                  } else {
                    setIndirizzoScelto({ is_fatturazione: true })
                    handleAddIndirizzoInModal()
                  }
                }}
              />
            </>
          )}

          {!isIndirizziValid && (
            <div className="checkout__indirizzo-spedizione-fatturazione__error">
              <p>
                {t('Verifica di aver inserito tutte le informazioni obbligatorie sugli indirizzi.')}
              </p>
            </div>
          )}
        </div>

        {
          <Button
            disabled={
              tipoSpedizione &&
              props.values.tipo_spedizione !== 'Spedizione' &&
              isIndirizziValid &&
              (isSpedizioneVisibile ? selectedIndirizzo && props.values.indirizzo : true) &&
              (props.values.fattura_richiesta &&
              props.values.indirizzi_diversi &&
              isFatturazioneVisibile
                ? selectedIndirizzoFatturazione && props.values.indirizzo_fatturazione
                : true)
                ? false
                : true
            }
            label={t('Conferma dati')}
            variant="primary"
            size="medium"
            onClick={() => {
              setStep(step + 1)
              handleScroll()
              trackingCheckout(carrello_main, 2, tipoSpedizione)
            }}
          />
        }
      </div>

      {showSceltaIndirizzoModal && indirizzoScelto?.id && (
        <SceltaIndirizzoSg
          indirizzo={indirizzoScelto}
          indirizzi={
            indirizzoScelto?.is_fatturazione
              ? indirizziFatturazione.filter((x) => x.id !== indirizzoScelto?.id)
              : indirizzi.filter((x) => x.id !== indirizzoScelto?.id)
          }
          setIndirizzo={setIndirizzoTmp}
          handleAddIndirizzo={handleAddIndirizzoInModal}
          handleSetIndirizzo={handleSetIndirizzoInModal}
          handleEditIndirizzo={handleEditIndirizzoInModal}
          handleDeleteIndirizzo={handleDeleteIndirizzoInModal}
          onClose={() => showModals(false, false)}
        />
      )}

      {showFormIndirizzoModal && (
        <FormIndirizzoSg
          variant="modal"
          onClose={() => {
            handleAnnullaIndirizzoInModal()
            onClose()
          }}
          isModal={true}
          editIndirizzo={indirizzoEdit}
          handleSaveIndirizzo={handleSaveIndirizzoInModal}
          fatturazione={indirizzoScelto?.is_fatturazione}
        />
      )}
    </>
  )
}

export default IndirizzoSpedizioneFatturazione
